import React from 'react';
import { Offcanvas, Button, Form, Card, Row, Col, Image, Spinner } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import Avatar from 'assets/images/avatar/avatar.jpg';

function OffCanvasEditUser({ show, onHide, userToEdit, handleEditUser, isLoadingButtonUserEdit, auth }) {
    const { t } = useTranslation();

    return (
        <Offcanvas show={show} onHide={onHide} placement="end">
            <Offcanvas.Header closeButton>
                <Offcanvas.Title><h2>{t('Edit User')}</h2></Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>
                {/* Form */}
                <Form onSubmit={handleEditUser}>
                    <Card className="mb-4">
                        <Card.Header className="card-header-height d-flex justify-content-between align-items-center">
                            <h4 className="mb-0">{t('Personal Information')}</h4>
                        </Card.Header>
                        <Card.Body className="">
                            <div className="text-center">
                                <Image
                                    src={Avatar}
                                    className="rounded-circle avatar-xl mb-3"
                                    alt=""
                                />
                            </div>
                            <Row className="mb-4">
                                <Col lg={12} md={12} className="mb-0">
                                    {/* First Name */}
                                    <Form.Group className="mb-3">
                                        <Form.Label htmlFor="password">{t('First Name')}</Form.Label>
                                        <Form.Control
                                            type="text"
                                            id="firstname"
                                            placeholder={t('Enter First Name')}
                                            autoComplete="given-name"
                                            defaultValue={userToEdit ? userToEdit.user_first_name : ''}
                                            required
                                        />
                                    </Form.Group>
                                </Col>
                                <Col lg={12} md={12} className="mb-0">
                                    {/* Last Name */}
                                    <Form.Group className="mb-3">
                                        <Form.Label htmlFor="password">{t('Last Name')}</Form.Label>
                                        <Form.Control
                                            type="text"
                                            id="lastname"
                                            placeholder={t('Enter Last Name')}
                                            autoComplete="family-name"
                                            defaultValue={userToEdit ? userToEdit.user_last_name : ''}
                                            required
                                        />
                                    </Form.Group>
                                </Col>
                                <Col lg={12} md={12} className="mb-0">
                                    {/* E-Mail */}
                                    <Form.Group className="mb-3">
                                        <Form.Label htmlFor="password">{t('Email')}</Form.Label>
                                        <Form.Control
                                            type="email"
                                            id="username"
                                            placeholder={t('Enter Email')}
                                            autoComplete="username"
                                            defaultValue={userToEdit ? userToEdit.user_username : ''}
                                            required
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                    <Card className="mb-4">
                        <Card.Header className="card-header-height d-flex justify-content-between align-items-center">
                            <h4 className="mb-0">{t('Permissions')}</h4>
                        </Card.Header>
                        <Card.Body className="">
                            <Row className="mb-0">
                                <Col lg={12} md={12} className="mb-0">
                                    {/* Role */}
                                    <div className="d-flex justify-content-between px-3 mt-2">
                                        <span>{t('Company Administrator')}</span>
                                        <Form.Check
                                            type="checkbox"
                                            label=""
                                            className="form-switch"
                                            onChange={(e) => {
                                                const newRoleId = e.target.checked ? "a237047f-cdd6-11ef-8d7a-0242ac120009" : "f65b80f5-cf5d-11ef-8d7a-0242ac120009";
                                                //setUserToEdit({ ...userToEdit, role_id: newRoleId });
                                            }}
                                            defaultChecked={userToEdit && userToEdit.role_id === "a237047f-cdd6-11ef-8d7a-0242ac120009"}
                                            disabled={userToEdit && userToEdit.user_username === auth.username}
                                        />
                                        <input type="hidden" id="role_id" value={userToEdit ? userToEdit.role_id : "f65b80f5-cf5d-11ef-8d7a-0242ac120009"} />
                                    </div>
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                    <div className="d-flex justify-content-end mt-4">
                        <Button variant="secondary" onClick={onHide}>
                            {t('Cancel')}
                        </Button>
                        <Button className="ms-2 d-end" variant="primary" type="submit" disabled={isLoadingButtonUserEdit}>
                            {isLoadingButtonUserEdit ? (
                                <>
                                    <Spinner animation="border" size="sm" className="me-2" />
                                    {t('Edit User')}
                                </>
                            ) : (
                                t('Edit User')
                            )}
                        </Button>
                    </div>
                </Form>
            </Offcanvas.Body>
        </Offcanvas>
    );
}

export default OffCanvasEditUser;